import { IconTrash } from "@aksara-ui/icons";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  Stack,
  Text,
  theme,
} from "@aksara-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteRaffleAncol, getAllRaffleAncol } from "redux/actions/raffleAncolActions";

interface Props {
  raffleId: string;
  currentPage?: number;
  limitPage?: number;
  searchValue?: string;
}

const RaffleAncolConfirmationModal: React.FC<Props & DialogProps> = ({
  isOpen,
  onClose,
  raffleId,
  currentPage = 1,
  limitPage = 10,
  searchValue = "",
}) => {
  const dispatch = useDispatch();
  const { isFormLoading } = useSelector((state: any) => state.raffleAncolReducer);

  const handleCloseModal = () => {
    onClose && onClose();
  };

  const handleDeleteRaffle = (raffleId: string) => {
    dispatch(
      deleteRaffleAncol(raffleId, () => {
        handleCloseModal();
        dispatch(getAllRaffleAncol(currentPage, searchValue, limitPage) as any);
      }) as any
    );
  };

  return (
    <Dialog disableOverlayClick isOpen={isOpen} onClose={handleCloseModal}>
      <DialogHeader></DialogHeader>
      <DialogContent>
        <Stack
          spacing="md"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Box
            backgroundColor={theme.colors.red01}
            size={80}
            borderRadius={100}
            display="flex"
            alignItems="center"
            justifyContent="center"
            color={theme.colors.red05}
          >
            <IconTrash size={50} fill={theme.colors.red05} />
          </Box>
          <Text scale={400}>Are you sure you want to delete this raffle reward?</Text>
        </Stack>
      </DialogContent>
      <DialogFooter>
        <Stack
          display="flex"
          flexDirection="row"
          spacing="xs"
          flex={1}
          style={{ gap: 15 }}
        >
          <Button variant="outline" block onClick={handleCloseModal}>
            Cancel
          </Button>

          <Button
            variant="destructive"
            block
            isLoading={isFormLoading}
            onClick={() => handleDeleteRaffle(raffleId)}
          >
            Delete
          </Button>
        </Stack>
      </DialogFooter>
    </Dialog>
  );
};

export default RaffleAncolConfirmationModal;
